import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { getModuleIconComponent } from '../../utils/moduleUtils';
import { MODULE_CAPABILITIES } from '../../moduleConfig';
import { toRgba } from '../../../../ui/theme/colors';
import theme from '../../../../ui/theme';
import { Typo } from '../../../../ui';

const PreviewContainer = styled.div`
  position: fixed;
  pointer-events: none;
  z-index: 9999;
  left: ${({ $x }) => $x}px;
  top: ${({ $y }) => $y}px;
  transform: translate(-50%, -50%);
  padding: 10px 16px;
  background: ${({ $bgColor }) => $bgColor};
  border: 2px solid ${({ $borderColor }) => $borderColor};
  border-radius: 8px;
  box-shadow: 0 8px 24px ${toRgba(theme.colors.NEU_999, 0.15)};
  display: flex;
  align-items: center;
  gap: 8px;
`;

/**
 * OrganizerDragPreview - Custom drag preview that follows the cursor
 */
const OrganizerDragPreview = ({ moduleType, x, y, themeColor }) => {
  const { t } = useTranslation();
  const IconComponent = getModuleIconComponent(moduleType);
  const labelKey = MODULE_CAPABILITIES[moduleType]?.labelKey;
  const moduleLabel = labelKey ? t(labelKey) : moduleType;

  const bgColor = toRgba(themeColor, 0.12);
  const borderColor = toRgba(themeColor, 0.4);

  return (
    <PreviewContainer $x={x} $y={y} $bgColor={bgColor} $borderColor={borderColor}>
      <IconComponent size='small' color={themeColor} />
      <Typo.Info fontWeight='600' color={themeColor}>
        {moduleLabel}
      </Typo.Info>
    </PreviewContainer>
  );
};

export default OrganizerDragPreview;
